// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("/Users/taf/gatsby-starter-ghost/node_modules/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-templates-post-js": () => import("/Users/taf/gatsby-starter-ghost/src/templates/post.js" /* webpackChunkName: "component---src-templates-post-js" */),
  "component---src-templates-index-js": () => import("/Users/taf/gatsby-starter-ghost/src/templates/index.js" /* webpackChunkName: "component---src-templates-index-js" */),
  "component---src-templates-author-js": () => import("/Users/taf/gatsby-starter-ghost/src/templates/author.js" /* webpackChunkName: "component---src-templates-author-js" */),
  "component---src-pages-404-js": () => import("/Users/taf/gatsby-starter-ghost/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/Users/taf/gatsby-starter-ghost/.cache/data.json")

